import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';

@Component({
    imports: [RouterLink],
    selector: 'rdx-info-link',
    styleUrls: ['./info-link.component.scss'],
    templateUrl: './info-link.component.html',
})
export class InfoLinkComponent {
    constructor(private configService: ConfigService) {}

    get nonProdVersionDisplay(): string | undefined {
        const hostEnvironment = this.configService.environment;
        const servicesEnvironment = this.getServicesEnvironment();
        return this.configService.isProd || hostEnvironment === 'prod'
            ? undefined
            : `${hostEnvironment} (${servicesEnvironment} services)`;
    }

    getServicesEnvironment(): Environment {
        if (this.configService.isProd) {
            return 'prod';
        }

        return this.configService.apiUrl.rideCommand.includes('stage.')
            ? 'stage'
            : 'dev';
    }
}
